export default __webpack_public_path__ + "static/media/Hardware Free Left.2a8095eb.png";